/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Everywhere_DescInputs */

const en_wc_why_everywhere_desc = /** @type {(inputs: Wc_Why_Everywhere_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One Rust codebase for Windows, macOS, Linux, BSD and the browser, drawn natively on the GPU.`)
};

/**
* | output |
* | --- |
* | "One Rust codebase for Windows, macOS, Linux, BSD and the browser, drawn natively on the GPU." |
*
* @param {Wc_Why_Everywhere_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_everywhere_desc = /** @type {((inputs?: Wc_Why_Everywhere_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Everywhere_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_everywhere_desc(inputs)
});
export { wc_why_everywhere_desc as "wc.why.everywhere.desc" }